import { render, staticRenderFns } from "./SalesOrdersPerSegmentsChart.vue?vue&type=template&id=3196b3ec&scoped=true"
import script from "./SalesOrdersPerSegmentsChart.vue?vue&type=script&lang=js"
export * from "./SalesOrdersPerSegmentsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196b3ec",
  null
  
)

export default component.exports